import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SalesTemplatesIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SalesTemplates",
    children: /*#__PURE__*/_jsx("path", {
      d: "M23.94 8.54h-9.35c-1.81 0-3.27 1.46-3.27 3.27v14.92c0 1.81 1.46 3.27 3.27 3.27h9.35c1.81 0 3.27-1.46 3.27-3.27V11.81c0-1.81-1.46-3.27-3.27-3.27m-.47 2.8c.08-.02.18-.04.27-.04.54 0 .97.44.97.97a.977.977 0 0 1-1.25.93s-8.45 0-8.45 0a.97.97 0 0 1-.01-1.86s8.45 0 8.45 0Zm0 11.22h-8.45a.97.97 0 0 1-.01-1.86s8.41 0 8.41 0a.97.97 0 0 1 .01 1.86s.04 0 .04 0m0-4.67h-8.45a.97.97 0 0 1-.01-1.86s8.41 0 8.41 0a.97.97 0 0 1 .01 1.86s.04 0 .04 0m-15.42 2.8a.47.47 0 0 1-.47-.47V5.27c0-.26.21-.47.47-.47h9.35c.26 0 .47.21.47.47v.02a1.4 1.4 0 0 0 2.8.02v-.04C20.67 3.46 19.21 2 17.4 2H8.05C6.24 2 4.78 3.46 4.78 5.27v14.95c0 1.81 1.46 3.27 3.27 3.27.77 0 1.4-.63 1.4-1.4s-.63-1.4-1.4-1.4"
    })
  }));
};